import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Certificate from "./pages/Certificate";
import Product from "./pages/Product";
import InquiryPopup from "./Componets/InquiryPopup";
import Product1 from "./pages/Product/Product1";
import HighPerformanceDrills from "./pages/Product/High-Performance-Drills";
import HighPerformanceEndmills from "./pages/Product/high-performance-endmills";
import ChamferTools from "./pages/Product/ChamferTools";
import CustomizedTools from "./pages/Product/Customizedtools";
// import Productdesign from "./Componets/productdesign";
import useScriptReloader from "./hooks/useScriptReloader";
import ScrollToTop from "./Componets/ScrollToTop";
import BallnoseEndmills from "./pages/Product/Ballnose-Endmills";
import Reamer from "./pages/Product/Reamer";



function App() {
  useScriptReloader();
  return (
    <>
    <ScrollToTop/>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/product" element={<Product />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/certificate" element={<Certificate />} />
        <Route exact path="/product/:slug" element={<Product1 />} />
        <Route
          exact
          path="/high-performance-drills"
          element={<HighPerformanceDrills />}
        />
        <Route
          exact
          path="/high-performance-endmills"
          element={<HighPerformanceEndmills />}
        />
        <Route exact path="/chamfer-tools" element={<ChamferTools />} />
        <Route exact path="/reamer" element={<Reamer />} />
        <Route exact path="/ballnose-endmills" element={<BallnoseEndmills/>} />
        <Route exact path="/InquiryPopup" element={<InquiryPopup />} />
        <Route exact path="/customized-tools" element={<CustomizedTools />} />
        {/* <Route exact path="/Productdesign" element={<Productdesign/>}/> */}
      </Routes>
    </>
  );
}

export default App;
